export const DISPLAY_NONE_VALUE = 'none'
